<template>
  <div class="room_cabin_detail border-grey">
    <div class="room_cabinPay">
      <div class="room_cabin_m">
        <div class="cabin_detail_img" @click="onStateroomClicked($event)">
          <img class="qiaohu_tag"
            :class="GlobalData.groupTypeValues[stateroom.groupType]"
            v-lazy="stateroom.stateroomDesImgUrl"
            :alt="stateroomName"
          />
          <img class="suite-tag"
               v-if="stateroomType === 'DELUXE' && stateroomTag >= 0"
               :src="GlobalData.suiteImgValue[stateroomTag]"/>
          <img class="pcp-gift-icon"
               v-if="stateroom.groupType === 'PCPGIFT'"
               v-lazy="stateroom.personalizedStateroomInfo?.roomIconImage"
               :alt="stateroom.groupType"
          />
        </div>
        <div class="cabin_detail_desc">
          <div class="detail_desc_info">
            <div class="detail_desc_name">
              <div class="detail_desc_nameTxt">{{ stateroomName }}</div>
              <img class="deluxe-tag"
                   v-if="stateroomType === 'DELUXE' && stateroomTag >= 0"
                   @click="onShowStateroomSuitePopup(stateroom.suiteMobileImageUrl)"
                   :src="GlobalData.suiteTagImgValue[stateroomTag]"/>
<!--              <img class="deluxe-tag" -->
<!--                v-if="stateroomTag && stateroomTag.indexOf('银钻')>=0" -->
<!--                @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--                src="https://resource.rcclchina.com.cn/wechatMiniProgram/deluxe-silver.png"/>-->
<!--              <img class="deluxe-tag" -->
<!--                v-else-if="stateroomTag && stateroomTag.indexOf('金钻')>=0" -->
<!--                @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--                src="https://resource.rcclchina.com.cn/wechatMiniProgram/deluxe-gold.png"/>-->
<!--              <img class="deluxe-tag" -->
<!--                v-else-if="stateroomTag && stateroomTag.indexOf('星钻')>=0" -->
<!--                @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--                src="https://resource.rcclchina.com.cn/wechatMiniProgram/deluxe-diamond.png"/>-->
<!--              <div-->
<!--                v-else-if="stateroomTag.length > 0"-->
<!--                class="cabin_detail_tag"-->
<!--                @click="-->
<!--                  onShowStateroomSuitePopup(stateroom.suiteMobileImageUrl)-->
<!--                "-->
<!--              >-->
<!--                {{ stateroomTag }}-->
<!--              </div>-->
            </div>
            <div class="detail_desc_area">
              <span>{{ stateroom.stateroomArea }}</span
              ><span>{{ stateroomBalconyArea }}</span
              ><span>{{ stateroom.stateroomFloorInfo }}</span
              ><span>{{ stateroom.commentTag }}</span>
            </div>
          </div>
          <template v-if="stateroomType === 'DELUXE' && stateroomTag > 0">
            <DeviceFeatureTags v-if="stateroom.deviceFeatureTags" :view-num="2" is-detail :tags="stateroom.deviceFeatureTags"
                               @submit="onStateroomClicked($event)"></DeviceFeatureTags>
          </template>
          <template v-else>
            <DeviceFeatureTags v-if="stateroom.deviceFeatureTags" is-detail :tags="stateroom.deviceFeatureTags" @submit="onStateroomClicked($event)"></DeviceFeatureTags>
          </template>
          <img
              @click="onShowQiaohuPopup()"
              v-if="isQiaohu"
              class="QIAOHU_CSS qiaohu_tag"
              src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg"
          />
          <img
              @click="onShowStarrySkyPopup()"
              v-else-if="isStarrySky"
              class="STARRYSKY_CSS qiaohu_tag"
              src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png"
          />
          <img
              @click="onShowCustomThemePopup()"
              v-else-if="isPcpGiftTheme"
              class="PCP_GIFT_THEME_CSS qiaohu_tag"
              :src="stateroom.personalizedStateroomInfo.roomTransparentIconImage"
          />
          <img
              @click="onShowCustomThemePopup()"
              v-else-if="isCustomTheme"
              class="CUSTOM_THEME_CSS qiaohu_tag"
              :src="stateroom.personalizedStateroomInfo.roomIconImage"
          />
          <div class="detail_desc_price">
             <!-- 套房 标签 start -->
            <div v-if="stateroom.roomSummaryList && stateroom.roomSummaryList.length>0 && stateroom.suiteType > 0" class="tab-room-box"
              :class="[stateroom.suiteType == 1 ? 'tab-room-box-see':stateroom.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
              @click="showSuitePopup"
            >
              <div class="tab-room-box-left">
                <div class="tab-room-box-left-item" v-for="item in getTagsArr" :key="item">{{item}}</div>
              </div>
              <div class="tab-room-box-right">
                {{stateroom.suiteRightsCount}}项 <img :src="currImgUrl+'see.png'" class="tab-room-box-right-img" mode="" v-if="stateroom.suiteType == 1"/>
                <img :src="currImgUrl+'sky.png'" class="tab-room-box-right-img" mode="" v-if="stateroom.suiteType == 2"/>
                <img :src="currImgUrl+'star.png'" class="tab-room-box-right-img" mode="" v-if="stateroom.suiteType == 3"/>
              </div>
            </div>
            <!-- 套房 标签 end -->
            <div class="desc_price_txt">
              {{ priceType }}(含税):<span class="desc_price_unit">￥</span>
              <span class="stateroomTypePrice">{{ netAmountStr }}</span> /人起
            </div>
<!--            <div class="desc_price_txt2">-->
<!--              零售指导价(含税): ¥{{ originalAmountStr }}/人起-->
<!--            </div>-->
            
              <div v-if="amountPerNight" class="desc_per_night">平均每晚￥{{amountPerNight}}/人起</div>
              <div class="room_orderChange_box">
                <div
                  class="room_orderChange js-orderChangeBtn"
                  :class="{
                    Free_css: !stateroom.price || stateroom.price.length < 2,
                    'is-tik-tok': allowUseTikTokCode
                  }"
                  @click="onSelectNrpChange($event)"
                >
                  <div :class="{ active: selectNrp }" v-show="hasNrp">
                    {{ getNrpTitle(true) }}
                  </div>
                  <div :class="{ active: !selectNrp }" v-show="hasRp">
                    {{ getNrpTitle(false) }}
                  </div>
                </div>
                <img class="room_orderChange_icons"
                     @click="handleRoomUnsubscribedOpen($event)"
                     :src="`${imgUrl}/icons/iconQuestionMark.svg`"/>
              </div>
          </div>
          
          <div class="detail_skip_room">
            <div class="reduce_room" @click="shoppingCartDelete($event)">
              <i class="f7-icons">delete_round</i>
            </div>
            <span class="skip_room_number">
              <span class="skip_roomSelCount">{{ shoppingCartNum }}</span>
            </span>
            <div class="plus_room" @click="shoppingCartAdd($event)">
              <i class="f7-icons">add_round_fill</i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 收费/常规退订弹窗 -->
    <NrpPopup
        :isShow="isShowNrpPopup"
        :nrpDescription="nrpDescription"
        :onCloseNrpPopup="handleRoomUnsubscribedClose"
    />

    <StateroomSuitePopup v-if="stateroom"
                         :suiteImage="stateroom.suiteMobileImageUrl"
                         :isShow="isShowSuitePopup"
                         :onGoBack="closeSuitePopup"
    />
  </div>
</template>

<script>
import nrpConfig from "@/utilities/nrpConfig";
import { gioTracking, dateStrToTimeTamp } from "@/utilities/tools";
import NrpPopup from "@/components/Booking/NrpPopup.vue";
const StateroomSuitePopup = () => import('@/components/Cruise/StateroomSuitePopup')

const DeviceFeatureTags = ()=> import("@/components/Cruise/DeviceFeatureTags");
export default {
  name: "StateroomItem",
  components: {
    NrpPopup,
    DeviceFeatureTags,
    StateroomSuitePopup
  },
  props: {
    shipCode: {
      type: String,
      default() {
        return "";
      },
    },
    sailDate: {
      type: String,
      default() {
        return "";
      },
    },
    packageCode: {
      type: String,
      default() {
        return "";
      },
    },
    stateroom: {
      type: Object,
      default() {
        return {};
      },
    },
    guestNumber: {
      type: Number,
      default() {
        return 0;
      },
    },
    shoppingCarts: {
      type: Array,
      default() {
        return [];
      },
    },
    stateroomType: {
      type: String,
      default() {
        return "";
      },
    },
    qiaohuGroup: {
      type: Object,
      default() {
        return {};
      },
    },
    onShoppingCartAdd: {
      type: Function,
    },
    onShoppingCartDelete: {
      type: Function,
    },
    showStateroomDetail: {
      type: Function,
    },
    showStateroomSuitePopup: {
      type: Function,
    },
    showQiaohuPopup: {
      type: Function,
    },
    showStarrySkyPopup: {
      type: Function
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
    },
    test: {
      type: Number
    },
    nrpDefaultSelectedType: {
      type: Number
    },
    allowUseTikTokCode: {
      type: Boolean,
      default: false
    },
    showCustomThemePopup: {
      type: Function
    },
        showRow: {
            type: Boolean,
            default () {
                return false
            }
        },
  },
  data() {
    return {
      currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',
      imgUrl: process.env.VUE_APP_IMG_URL,
      selectNrp: false,
      isShowNrpPopup: false,
      isShowSuitePopup:false,
      nrpDescription: ""
    };
  },
  beforeMount() {
    this.initSelectNrp();
  },
  methods: {
    closeSuitePopup() {
      this.isShowSuitePopup = false;
    },
    showSuitePopup() {
      if(this.shipCode === 'OV') return;
      this.isShowSuitePopup = true;
    },
    initSelectNrp() {
      if (!this.stateroom.price || this.stateroom.price.length == 0) {
        return;
      }
      let nrp = 0;
      const nrpPrice = this.stateroom.price.filter((r) => r.isnrp);
      nrp = nrpPrice.length > 0 ? nrpPrice[0].netAmount : 0;
      let rp = 0;
      const rpPrice = this.stateroom.price.filter((r) => !r.isnrp);
      rp = rpPrice.length > 0 ? rpPrice[0].netAmount : 0;

      if(this.allowUseTikTokCode) {
        rp = 0;
      }
      // 临时修改，不管NRP和RP的价格高低，都默认选中RP价格
      // if (nrp > 0 && nrp <= rp) {
      //     this.selectNrp = true
      // } else {
      //     this.selectNrp = false
      // }
      // }

      //nrpDefaultSelectedType 0:默认-按nrp 1:常规rp | 2:收费nrp
      if (rp > 0 && nrp > 0) {
        this.selectNrp = this.nrpDefaultSelectedType === 0 || this.nrpDefaultSelectedType === 2;
      } else if (rp > 0) {
        this.selectNrp = false;
      } else if (nrp > 0) {
        this.selectNrp = true;
      }
    },    //根据默认选中收费退订
    getCurrentIsNrpDefault() {
      let currDate = dateStrToTimeTamp(this.sailDate);
      let beginDate = dateStrToTimeTamp("2024-07-03");
      let endDate = dateStrToTimeTamp("2024-08-24");
      return this.shipCode === 'SC' && (currDate >= beginDate && currDate <= endDate);
    },
    onSelectNrpChange(e) {
      e.stopPropagation();
      if (this.selectNrp == false && this.hasNrp) {
        this.selectNrp = true;
      } else if (this.selectNrp == true && this.hasRp) {
        this.selectNrp = false;
      }
    },
    shoppingCartAdd(e) {
      e.stopPropagation();
      const price = this.stateroom.price.filter(
        (r) => r.isnrp == this.selectNrp
      );
      if (!price || price.length == 0) {
        return;
      }
      let model = {
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        productPackageId: -1,
        packageId: this.packageCode,
        stateroomCategoryCode: this.stateroom.stateroomCategoryCode,
        stateroomClass: this.stateroomType,
        fareCode: price[0].fareCode,
        guestNumber: this.guestNumber,
        originAmount: price[0].originalAmount / this.guestNumber,
        netAmount: price[0].netAmount / this.guestNumber,
        amountPerNight: price[0].amountPerNight,
        isNrp: this.selectNrp,
        groupAgencyId: "",
        groupAgencyName: "",
        requestsequence: "",
        groupType: "",
        groupId: "",
        connectId: "",
      };

      if (this.stateroom.groupType == "QIAOHU") {
        model.groupAgencyId = this.qiaohuGroup.agencyId || "";
        model.groupAgencyName = this.qiaohuGroup.agencyName || "";
        model.requestsequence = this.stateroom.requestsequence || "";
        model.groupType = this.qiaohuGroup.groupType || "";
        model.groupId = this.qiaohuGroup.groupId || "";
      }

      this.onShoppingCartAdd(model);

      try {
        if (window && window.gio) {
          if (model.isNrp) {
            gioTracking("track", "NRP_BF01");
          }
          gioTracking("track", "AddRoom", {
            GuestNumber: model.guestNumber,
            RoomClass: model.stateroomClass,
            RoomCategory: model.stateroomCategoryCode,
						RoomType: this.stateroom.groupType == "QIAOHU" ? 'Qiaohu' : 'nil',
            shipCode:this.shipCode,
            sailDate:this.sailDate
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    shoppingCartDelete(e) {
      e.stopPropagation();
      if (this.shoppingCartNum > 0) {
        const price = this.stateroom.price.filter(
          (r) => r.isnrp == this.selectNrp
        );
        if (!price || price.length == 0) {
          return;
        }
        let model = {
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          productPackageId: -1,
          packageId: this.packageCode,
          stateroomCategoryCode: this.stateroom.stateroomCategoryCode,
          stateroomClass: this.stateroomType,
          fareCode: price[0].fareCode,
          guestNumber: this.guestNumber,
          originAmount: price[0].originalAmount / this.guestNumber,
          netAmount: price[0].netAmount / this.guestNumber,
          amountPerNight: price[0].amountPerNight,
          isNrp: this.selectNrp,
          groupAgencyId: "",
          groupAgencyName: "",
          requestsequence: "",
          groupType: "",
          groupId: "",
          connectId: "",
        };
        if (this.stateroom.groupType == "QIAOHU") {
          model.groupAgencyId = this.qiaohuGroup.agencyId || "";
          model.groupAgencyName = this.qiaohuGroup.agencyName || "";
          model.requestsequence = this.stateroom.requestsequence || "";
          model.groupType = this.qiaohuGroup.groupType || "";
          model.groupId = this.qiaohuGroup.groupId || "";
        }
        this.onShoppingCartDelete(model);
      }
    },
    onStateroomClicked(e) {
      e.stopPropagation();
      const stateroomData = {
        stateroomImages: this.stateroom.stateroomImages,
        stateroomName: this.stateroom.stateroomCNName,
        stateroomCategory: this.stateroom.stateroomCategoryCode,
        stateroomPriceType: this.priceType,
        stateroomPrice: this.netAmount,
        stateroomCapacity: this.stateroom.stateroomCapacity,
        stateroomArea: this.stateroom.stateroomArea,
        stateroomBalcony: this.stateroom.stateroomBalconyArea,
        stateroomFloor: this.stateroom.stateroomFloorInfo,
        isQiaohu: this.isQiaohu,
        isStarrySky: this.isStarrySky,
        isPcpGiftTheme: this.isPcpGiftTheme,
        isCustomTheme: this.isCustomTheme,
        stateroomDescription: this.stateroom.stateroomDescription,
        stateroomNrpTitle: this.nrpTitle,
        stateroomNrpText: this.nrpText,
        suiteMobileImageUrl: this.stateroom.suiteMobileImageUrl,
        suiteType: this.stateroom.suiteType,
        stateroomType: this.stateroomType,
        suiteImageUrl: this.stateroom.suiteImageUrl,

        stateroomImageDataList: this.stateroom.stateroomImageDataList,
        roomSummaryList: this.stateroom.roomSummaryList,
        suiteRightsCount: this.stateroom.suiteRightsCount,
        vrUrl: this.stateroom.vrUrl,
        currentGuestNumber: this.stateroom.currentGuestNumber,
        guestNumber: this.stateroom.guestNumber,

        deviceFeatureTags: this.stateroom.deviceFeatureTags,
        deviceGroupTags: this.stateroom.deviceGroupTags,
        personalizedStateroomInfo: this.stateroom.personalizedStateroomInfo
      };
      this.showStateroomDetail(stateroomData);
      gioTracking('track', 'evt_RoomDetailClick', {
        'GuestNumber': this.guestNumber,
        'RoomType': this.stateroom.groupType == "QIAOHU" ? 'Qiaohu' : 'nil',
        'RoomClass': this.stateroomType,
        'RoomCategory': this.stateroom.stateroomCategoryCode,
        'shipCode': this.shipCode,
        'sailDate': this.sailDate
      });
    },
    onShowStateroomSuitePopup(suiteImage) {
      if (suiteImage && suiteImage.length > 0 && this.shipCode !== 'OV') {
        this.showStateroomSuitePopup(suiteImage);
      }
    },
    onShowQiaohuPopup() {
      this.showQiaohuPopup();
    },
    onShowStarrySkyPopup() {
      this.showStarrySkyPopup();
    },
    onShowCustomThemePopup() {
      this.showCustomThemePopup(this.stateroom.personalizedStateroomInfo);
    },
    getNrpTitle(isNrp) {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.title;
      } else if (isNrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    handleRoomUnsubscribedOpen(e) {
      e.stopPropagation();
      this.isShowNrpPopup = true;
      // this.nrpDescription = this.selectNrp ? nrpConfig.nrp.description : nrpConfig.rp.description;
       if(this.selectNrp){
        // 收费退订
                if(this.showRow){
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
      }else{
        // 常规退订
                if(this.showRow){
                    this.nrpDescription =  this.$store.state.cruiseRow.nrpData.cancelPolicyRow
                }else{
                    this.nrpDescription = this.$store.state.cruiseRow.nrpData.cancelPolicy
                }
      }
    },
    handleRoomUnsubscribedClose() {
      this.isShowNrpPopup = false;
      this.nrpDescription = "";
    }
  },
  computed: {
    getTagsArr(){
      if(this.stateroom.roomSummaryList  && this.stateroom.roomSummaryList.length > 0){
        if(this.stateroom.roomSummaryList.length == 2){
          return this.stateroom.roomSummaryList
        }else{
          return this.stateroom.roomSummaryList.slice(0,2)
        }
      }else{
        return []
      }
    },
    stateroomName() {
      return this.stateroom.stateroomCNName + "_" + this.categoryCode;
    },
    stateroomBalconyArea() {
      if (
        !this.stateroom.stateroomBalconyArea ||
        this.stateroom.stateroomBalconyArea.length == 0 ||
        this.stateroom.stateroomBalconyArea == "无"
      ) {
        return "无阳台";
      }
      return this.stateroom.stateroomBalconyArea;
    },
    priceType() {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.priceType;
      } else if (this.selectNrp) {
        return nrpConfig.nrp.priceType;
      }
      return nrpConfig.rp.priceType;
    },
    nrpTitle() {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.title;
      } else if (this.selectNrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    nrpText() {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.description;
      } else if (this.selectNrp) {
        return nrpConfig.nrp.description;
      } else {
        return nrpConfig.rp.description;
      }
    },
    netAmount() {
      let price = 0;
      const priceObj = this.stateroom.price.filter(
        (r) => r.isnrp == this.selectNrp
      );
      price = priceObj.length > 0 ? priceObj[0].perPeopleAmount : 0;
      return price;
    },
    netAmountStr() {
      let price = this.netAmount;
      if (price == 0) {
        return "";
      }
      return price.toFixed(0);
    },
    amountPerNight() {
      if(this.stateroom.price.length === 1) {
        return this.stateroom.price[0]?.perNightAmount ? this.stateroom.price[0]?.perNightAmount.toFixed(0) : null;
      } else {
        if (this.selectNrp) {
          return this.stateroom.price[0]?.perNightAmount ? this.stateroom.price[0]?.perNightAmount.toFixed(0) : null;
        } else {
          return this.stateroom.price[1]?.perNightAmount ? this.stateroom.price[1]?.perNightAmount.toFixed(0) : null;
        }
      }
    },
    originalAmountStr() {
      let price = this.stateroom.originalAmount / this.guestNumber;
      if (price == 0) {
        return "";
      }
      return price.toFixed(0);
    },
    shoppingCartNum() {
      return this.shoppingCarts.filter(
        (r) =>
          r.berthedCategoryCode == this.stateroom.stateroomCategoryCode &&
          r.isnrp == this.selectNrp &&
          (!r.connectId || r.connectId == "") &&
          r.guestNumber == this.guestNumber
      ).length;
    },
    hasNrp() {
      if(this.allowUseTikTokCode) {
        return true;
      }
      return this.stateroom.price && this.stateroom.price.some((r) => r.isnrp)
    },
    hasRp() {
      if(this.allowUseTikTokCode) {
        return false;
      }
      return this.stateroom.price && this.stateroom.price.some((r) => !r.isnrp);
    },
    isQiaohu() {
      return this.stateroom.groupType && this.stateroom.groupType == "QIAOHU";
    },
    isStarrySky() {
      return this.stateroom.groupType && this.stateroom.groupType == "STARRYSKY";
    },
    isPcpGiftTheme() {
      return this.stateroom.groupType && (this.stateroom.groupType == "PCPGIFT");
    },
    isCustomTheme() {
      return this.stateroom.groupType && (this.stateroom.groupType == "CUSTOM");
    },
    categoryCode() {
      let code = this.stateroom.stateroomCategoryCode + "";
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      return code;
    },
    stateroomTag() {
      // if (this.stateroom.tag && this.stateroom.tag.length > 0) {
      //   return this.stateroom.tag;
      // } else if (this.stateroom.suiteType == 1) {
      //   return "银卡礼遇";
      // } else if (this.stateroom.suiteType == 2) {
      //   return "金卡礼遇";
      // }
      return this.stateroom.suiteType;
    },
  },
  watch: {
    stateroom() {
      this.initSelectNrp();
    }
  },
};
</script>

<style lang="less" scoped>
.room_cabin_detail {
  position: relative;
  max-width: 375px;
  max-height: 225px;
  padding: 20px 10px;
  border-bottom: 1px solid #eee;
  .room_cabin_m {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    .cabin_detail_img {
      width: 100px;
      height: 100px;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
      }

      & .suite-tag {
        position: absolute;
        top: 5px;
        left: 5px;
        width: 50px;
      }
      & .pcp-gift-icon {
        position: absolute;
        top: 5px;
        left: 50%;
        margin-left: -30px;
        width: 60px;
      }
    }
    .cabin_detail_desc {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -moz-box-orient: vertical;
      -moz-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -moz-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      padding: 0 10px;
      /* overflow: hidden; */
      font-size: 12px;
      .detail_desc_info {
        .detail_desc_name {
          font-size: 14px;
          line-height: 1;
          color: #333;
          font-weight: bold;
          .detail_desc_nameTxt {
            margin-bottom: 8px;
            margin-right: 5px;
            display: inline-block;
          }
        }
        .detail_desc_area {
          font-size: 12px;
          line-height: 1;
          color: #666;
          span {
            display: inline-block;
          }
          span + span {
            margin-left: 10px;
            padding-left: 10px;
            border-left: 1px solid #979797;
          }
        }
      }
      .detail_desc_price {
        margin-top: 8px;
        font-size: 12px;
        .desc_price_txt {
          font-size: 10px;
          line-height: 14px;
          color: #666;
          font-weight: normal;
          span {
            font-size: 18px;
            line-height: 1;
            color: #ff5055;
            font-weight: bold;
          }
          span.desc_price_unit {
            font-size: 12px;
          }
        }
        .desc_price_txt2 {
          margin-top: 4px;
          font-size: 10px;
          line-height: 1;
          color: #aaa;
          text-decoration: line-through;
        }
        & .desc_per_night {
          line-height: 18px;
          letter-spacing: -1px;
          margin-top: 3px;
          color: #a6aeb1;
        }

        & .room_orderChange_box {
          display: flex;
          align-items: center;
          gap: 0 4px;
          & .room_orderChange {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            width: 112px;
            height: 18px;
            margin-top: 3px;
            background: #f3f6f7;
            border: 1px solid #d3dadd;
            border-radius: 10px;
            -webkit-border-radius: 10px;
            -moz-border-radius: 10px;

            > div {
              -webkit-box-flex: 1;
              -webkit-flex: 1;
              -moz-box-flex: 1;
              -ms-flex: 1;
              flex: 1;
              font-size: 10px;
              line-height: 16px;
              color: #a6aeb1;
              text-align: center;
            }

            > div.active {
              border: none;
              color: #fff;
              background: #4a90e2;
              border-radius: 10px;
              -webkit-border-radius: 10px;
              -moz-border-radius: 10px;
            }
            &.is-tik-tok {
              width: 70px;
            }
          }
          & .room_orderChange_icons {
            display: inline-flex;
            width: 16px;
            height: 16px;
            margin-top: 3px;
          }
        }
        .Free_css {
          width: 55px;
        }
      }

      .detail_skip_room {
        position: absolute;
        right: 0px;
        bottom: -2px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;

        .reduce_room .f7-icons,
        .plus_room .f7-icons {
          margin: 0;
          padding: 1px;
          font-size: 19px;
          color: #febc10;
        }
        .reduce_room .f7-icons {
          color: #4a90e2;
        }
        .skip_room_number {
          width: 29px;
          font-size: 15px;
          line-height: 1;
          color: #000;
          text-align: center;
        }
      }
    }
  }
}
.QIAOHU_CSS {
  background-size: 100% 100%;
  width: 113px;
  margin-top: 8px;
}
.STARRYSKY_CSS {
  background-size: 100% 100%;
  width: 113px;
  margin-top: 4px;
}
.PCP_GIFT_THEME_CSS {
  background-size: 100% 100%;
  width: 86px;
  margin-top: 8px;
}
.CUSTOM_THEME_CSS {
  background-size: 100% 100%;
  width: 90px;
  margin-top: 5px;
}
.QIAOHU_BACKGROUND_CSS {
  border: 2px solid #ffe100;
}
.STARRYSKY_BACKGROUND_CSS {
  border: 2px solid #ffe100;
}
.CUSTOM_BACKGROUND_CSS {
  border: 2px solid #ffe100;
}
.PCP_GIFT_BACKGROUND_CSS {
  border: 2px solid #ffe100;
}
.cabin_detail_tag {
  background-color: #fffae7;
  border-radius: 12px;
  border: solid 1px #ffa70d;
  font-size: 11px;
  color: #ffa70d;
  text-align: center;
  width: 72px;
  line-height: 16px;
  font-weight: normal;
  display: inline-block;
  margin-bottom: 5px;
  vertical-align: middle;
}

.deluxe-tag {
  width: 50px;
  display: inline-block;
  margin-bottom: 5px;
  vertical-align: middle;
}
.detail_desc_tags {
  margin-top: 6px;
  overflow: hidden;
  & .tags_list {
    float: left;
    & > li {
      display: inline-block;
      overflow: hidden;
      margin-right: 8px;
      height: 16px;
      & > img {
        float: left;
        height: 16px;
      }
      & > div {
        float: left;
        line-height: 15px;
        letter-spacing: -1px;
      }
    }
  }
  & .tags_arrow {
    float: left;
    margin-top: 3px;
  }
}

.tab-room-box{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0;
  // margin-bottom: 8px;
}
.tab-room-box-see{
  color: #43797D;
  border-color: #43797D;
}
.tab-room-box-sky{
  color: #3D60AF;
  border-color: #3D60AF;
}
.tab-room-box-star{
  color: #8B3C63;
  border-color: #8B3C63;
}
.tab-room-box-left{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.tab-room-box-left-item{
  font-weight: 400;
  font-size: 10px;
  padding: 1px 4px;
  border: 1px solid ;
  border-radius: 2px;
  margin-right: 4px;
  margin-bottom: 4px;
}
.tab-room-box-right{
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  flex-shrink: 0;
}
.tab-room-box-right-img{
  width: 10px;
  height: 10px;
  margin-left: 3px;
}
</style>
